import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSetNotification } from '../../../context/Notification';
import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { AssignCareManagersPayload, AssignCareManagersResponse } from '../types';
import { ORGANIZATION_MEMBER_LIST_KEY } from './constants';

const useAssignCareManagers = (onSuccess?: () => void) => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = ({ payload }: { payload: AssignCareManagersPayload }) => {
        return req<AssignCareManagersResponse>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/care-manager/assign/`,
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [ORGANIZATION_MEMBER_LIST_KEY] });
            setNotification({ message: 'Care manager assigned successfully' });
            onSuccess && onSuccess();
        },
        onError: (error?: { errors: string[] }) => {
            return error?.errors[0] || 'An error occurred while assigning care managers';
        }
    });
};

export default useAssignCareManagers;
